import React from "react";
import { Loading } from "../../components";
import { ApiHelper, DateHelper, ErrorLogInterface } from "../../helpers";

interface Props {
  screenId: number
}

export const ErrorLogs: React.FC<Props> = props => {

  const [errorLogs, setErrorLogs] = React.useState<ErrorLogInterface[]>(null);

  const init = () => { ApiHelper.get("/errorlogs/recent/" + props.screenId).then((data) => setErrorLogs(data)); }

  const getLogEntries = () => {
    const result: React.ReactElement[] = [];
    errorLogs?.forEach(l => {
      const displayTime = DateHelper.prettyDateTime(DateHelper.convertToDate(l.errorTime));
      result.push(<tr>
        <td>{displayTime}</td>
        <td>{l.url}</td>
        <td>{l.errorMessage}</td>
      </tr>);
    });
    return result;
  }

  React.useEffect(init, [props.screenId])

  if (errorLogs === null) return <Loading />
  else return (
    <>
      <h3>Recent Activity</h3>
      <table className="table table-sm" style={{ fontSize: 11 }}>
        <tbody><tr><th>Time</th><th>Url</th><th>Message</th></tr>
          {getLogEntries()}
        </tbody>
      </table>
    </>
  );
};